const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

export const DATE_PRESETS = [
  { id: "today", label: "Today" },
  { id: "yesterday", label: "Yesterday" },
  { id: "this_week", label: "This week" },
  { id: "last_week", label: "Last week" },
  { id: "this_month", label: "This month" },
  { id: "custom", label: "Custom range" },
];

export function istToday(now = new Date()) {
  return new Date(now.getTime() + IST_OFFSET_MS).toISOString().slice(0, 10);
}

export function addCalendarDays(dateStr, days) {
  const [year, month, day] = dateStr.split("-").map(Number);
  const next = new Date(Date.UTC(year, month - 1, day + days));
  return [
    next.getUTCFullYear(),
    String(next.getUTCMonth() + 1).padStart(2, "0"),
    String(next.getUTCDate()).padStart(2, "0"),
  ].join("-");
}

function startOfWeekMonday(dateStr) {
  const [year, month, day] = dateStr.split("-").map(Number);
  const dow = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  return addCalendarDays(dateStr, -((dow + 6) % 7));
}

export function istMidnightUtcMs(dateStr) {
  const [year, month, day] = dateStr.split("-").map(Number);
  return Date.UTC(year, month - 1, day) - IST_OFFSET_MS;
}

export function istHour(now = new Date()) {
  return new Date(now.getTime() + IST_OFFSET_MS).getUTCHours();
}

export function formatHourTick(hour) {
  const display = hour % 12 || 12;
  return `${display} ${hour < 12 ? "AM" : "PM"}`;
}

export function rangeForPreset(preset, now = new Date()) {
  const today = istToday(now);
  if (preset === "today") return { from: today, to: today };
  if (preset === "yesterday") {
    const yesterday = addCalendarDays(today, -1);
    return { from: yesterday, to: yesterday };
  }
  if (preset === "this_week") {
    return { from: startOfWeekMonday(today), to: today };
  }
  if (preset === "last_week") {
    const thisMonday = startOfWeekMonday(today);
    const lastSunday = addCalendarDays(thisMonday, -1);
    return { from: addCalendarDays(thisMonday, -7), to: lastSunday };
  }
  if (preset === "this_month") {
    return { from: `${today.slice(0, 8)}01`, to: today };
  }
  return { from: today, to: today };
}

export function comparisonLabel(preset) {
  if (preset === "today") return "vs yesterday";
  if (preset === "yesterday") return "vs prior day";
  if (preset === "this_week") return "vs last week";
  if (preset === "last_week") return "vs prior week";
  if (preset === "this_month") return "vs last month";
  return "vs prior period";
}

export function formatRangeLabel(from, to) {
  const start = formatShortDate(from);
  const end = formatShortDate(to);
  return from === to ? start : `${start} – ${end}`;
}

function formatShortDate(ymd) {
  const [year, month, day] = ymd.split("-").map(Number);
  const date = new Date(Date.UTC(year, month - 1, day, 12));
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
}

export function weekdayDateLabel(ymd) {
  const [year, month, day] = String(ymd || "").split("-").map(Number);
  if (!year || !month || !day) return "";
  const date = new Date(Date.UTC(year, month - 1, day, 12));
  const weekday = date.toLocaleDateString("en-US", {
    weekday: "short",
    timeZone: "UTC",
  });
  return `${weekday} ${day}`;
}

export function istYmdFromIso(iso) {
  if (!iso) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso;
  return new Date(new Date(iso).getTime() + IST_OFFSET_MS).toISOString().slice(0, 10);
}
